/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IProtocolDispatch } from "../shared/interfaces";

const controller = "ProtocolDispatches";

const getProtocolDispatches = (aooId: number, protocolId: number, uorId?: number, cancelToken?: CancelToken): Promise<IProtocolDispatch[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetProtocolDispatches/${protocolId}`, { cancelToken: cancelToken, params: { uorId: uorId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getProtocolDispatches
}